import React, { useState, useEffect } from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import TablaGeneral from "../../components/TablaGeneral";
import Loader from "../../components/Loader";
import configTable from "../../hook/configTable";

const PromocionesPage = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [datos, setDatos] = useState([])

  const eliminarItem = (id) => {
    console.log('eliminarItem', id);
    setIsLoading(true);
    try {
      fetch("/p_promocion",{
        method: "DELETE",
        headers:{
          "Content-Type": "application/json",
        },
        body: JSON.stringify({id})
      })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setDatos([])
        cargarDatos();
      });
    } catch (error) {
      console.error('Error:', error);
    }
  }

  const [datosTabla] = useState({
    titulo: "Promociones",
    ruta: "/promocion",
    esAgregar: true,
    esEditar: true,
    esEliminar: true,
    eliminar: eliminarItem,
    configTable: configTable,
    keySucursal: "ID_SUC_PRS"
  })

  const [cabecera] = useState([
    { title: "ID", key: "ID_PRO" },
    { title: "NOMBRE", key: "NOMBRE_PROMOCION_PRO" },
    { title: "ESTATUS", key: "ESTATUS_TEXTO_PRO" },
    { title: "SUCURSAL", key: "NOMBRE_SUCURSAL_SUC" },
    { title: "FECHA ALTA", key: "FECHA_ALTA_PRO", isDate: true }
  ]);

  const cargarDatos = async () => {
    try {
      fetch("/p_promociones",{
        method: "GET",
        headers:{
          "Content-Type": "application/json",
        }
      })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if(data.status === 1){
          setDatos(data.data);
        }
        setIsLoading(false);
      });
    } catch (error) {
      console.error('Error:', error);
    }
  };

  useEffect(() => {
    cargarDatos();
  }, []);
  return (
    <>
      <MasterLayout>
      { isLoading ? <Loader /> : <TablaGeneral datosTabla={datosTabla} datos={datos} cabecera={cabecera}/> }
      </MasterLayout>
    </>
  );
};

export default PromocionesPage;
